module.exports = __webpack_public_path__ + "static/como-lavar-80688f109f531a20162afc13a03eb686.png";